const ProductAnalysis = {
  path: "",
  name: "",
  redirect: "/product-analysis",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/product-analysis",
      redirect: "/product-analysis",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Product Analysis",
      meta: {
        requiresAuth: true,
        activeUrl: "/product-analysis",
        parent: "product-analysis",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/productAnalysis"),
          meta: {
            requiresAuth: true,
            activeUrl: "/product-analysis",
            parent: "product-analysis",

            lv: 2,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default ProductAnalysis;
